import { nextTick } from 'vue'

export function captureScrollAnchor(element) {
  if (!element) return null

  return {
    element,
    top: element.getBoundingClientRect().top
  }
}

export function restoreScrollAnchor(anchor) {
  if (!anchor?.element) return

  const delta = anchor.element.getBoundingClientRect().top - anchor.top
  if (delta !== 0) {
    window.scrollBy({ top: delta, left: 0 })
  }
}

function waitForFrames(count = 2) {
  return new Promise((resolve) => {
    let remaining = count

    const step = () => {
      remaining -= 1
      if (remaining <= 0) {
        resolve()
        return
      }
      requestAnimationFrame(step)
    }

    requestAnimationFrame(step)
  })
}

function wait(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}

/**
 * Kompensiert Layout-Verschiebungen oberhalb des Anker-Elements
 * (z. B. nach Apartment-Wechsel mit unterschiedlich hohem Content).
 * Erwartet einen zuvor mit captureScrollAnchor() erfassten Anker.
 */
export async function compensateScrollAfterLayout(anchor, delayMs = 180) {
  if (!anchor?.element) return

  await nextTick()
  await waitForFrames(2)
  await wait(delayMs)
  restoreScrollAnchor(anchor)

  // Fallback für spätes Layout (Swiper, matchHeight)
  await wait(170)
  restoreScrollAnchor(anchor)
}
